
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gs_45tmOQIPUzmDS0hDtQ1hfy_45R_KVfvZzr8VWEq7Tye9sMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index2Kcn8mR4ghQ4NSO1T23A7UtYi0TdJs5gxFNzqxuBi0gMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchTMjxJY00F_45h4Rt_45qf8x1j8WJ7g3VyM2yDoDLopeym1gMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexCl4hOZUq8Kzr1bbzztqOkPUdMUPm5LHtvyrcZOW43agMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93vDKt7CerBlv_45q8qANMexd4mVgz6N4wA_45bSyNh7WgDUsMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexa7PWSJGnJC6NOXU0_kk282gYPQBatMc2nU3PveqFlJEMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93EvvVzMFzHdA7jLQ0LwKCcgjsPjsWGmNokg0l5Q2u8ooMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexT6aeWDfEjgDPxdI0kibwoVpCkt_45erAlTroASbm24NXkMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93qZ1h5Ca8Y4E1UDcM8UfI3idIDjmVe98PRrfEHUAGjzwMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexeswjk_45R_F3Hupuoh2bxz2EBvhq_45Y_45aonRdNHzRwZy5kMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexZgijiqKEkuM7zrIYaaIa9AoUUBssbxat4XSqi6fRrkoMeta } from "/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexa7PWSJGnJC6NOXU0_kk282gYPQBatMc2nU3PveqFlJEMeta || {},
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexT6aeWDfEjgDPxdI0kibwoVpCkt_45erAlTroASbm24NXkMeta || {},
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexeswjk_45R_F3Hupuoh2bxz2EBvhq_45Y_45aonRdNHzRwZy5kMeta || {},
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexZgijiqKEkuM7zrIYaaIa9AoUUBssbxat4XSqi6fRrkoMeta || {},
    component: () => import("/codebuild/output/src4257417010/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]